import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 4H3v16h18V4zm-10 7H9.5v-.5h-2v3h2V13H11v2H6V9h5v2zm7 0h-1.5v-.5h-2v3h2V13H18v2h-5V9h5v2z"
}), 'ClosedCaptionSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ClosedCaptionSharp.js
// module id = 2826
// module chunks = 2